"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filteredDenominations = exports.initialBuyInDenominations = exports.allMoneyDenominations = void 0;
/**
 * allMoneyDenominations.ts
 *
 * This const returns UI friendly display name for denominations in dropdown
 * The Denomination enum is used as value and respective title is set
 */
const Denomination_1 = require("../enums/Denomination");
exports.allMoneyDenominations = [
    { label: "1¢", value: Denomination_1.Denomination.ONE_CENT },
    { label: "2¢", value: Denomination_1.Denomination.TWO_CENT },
    { label: "5¢", value: Denomination_1.Denomination.FIVE_CENT },
    { label: "10¢", value: Denomination_1.Denomination.TEN_CENT },
    {
        label: "25¢",
        value: Denomination_1.Denomination.TWENTY_FIVE_CENT,
    },
    { label: "50¢", value: Denomination_1.Denomination.FIFTY_CENT },
    { label: "$1", value: Denomination_1.Denomination.ONE_DOLLAR },
    { label: "$2", value: Denomination_1.Denomination.TWO_DOLLAR },
    { label: "$3", value: Denomination_1.Denomination.THREE_DOLLAR },
    { label: "$4", value: Denomination_1.Denomination.FOUR_DOLLAR },
    { label: "$5", value: Denomination_1.Denomination.FIVE_DOLLAR },
    { label: "$10", value: Denomination_1.Denomination.TEN_DOLLAR },
    {
        label: "$20",
        value: Denomination_1.Denomination.TWENTY_DOLLAR,
    },
    {
        label: "$25",
        value: Denomination_1.Denomination.TWENTY_FIVE_DOLLAR,
    },
    {
        label: "$40",
        value: Denomination_1.Denomination.FORTY_DOLLAR,
    },
    {
        label: "$50",
        value: Denomination_1.Denomination.FIFTY_DOLLAR,
    },
    {
        label: "$100",
        value: Denomination_1.Denomination.HUNDRED_DOLLAR,
    },
    {
        label: "$200",
        value: Denomination_1.Denomination.TWO_HUNDRED_DOLLAR,
    },
    {
        label: "$300",
        value: Denomination_1.Denomination.THREE_HUNDRED_DOLLAR,
    },
    {
        label: "$500",
        value: Denomination_1.Denomination.FIVE_HUNDRED_DOLLAR,
    },
];
exports.initialBuyInDenominations = exports.allMoneyDenominations.filter((denomination) => ![
    Denomination_1.Denomination.ONE_CENT,
    Denomination_1.Denomination.TWO_CENT,
    Denomination_1.Denomination.FIVE_CENT,
    Denomination_1.Denomination.TEN_CENT,
    Denomination_1.Denomination.TWENTY_FIVE_CENT,
    Denomination_1.Denomination.FIFTY_CENT,
].includes(denomination.value));
exports.filteredDenominations = exports.allMoneyDenominations.filter((denomination) => ![
    Denomination_1.Denomination.TWENTY_DOLLAR,
    Denomination_1.Denomination.FORTY_DOLLAR,
    Denomination_1.Denomination.TWO_HUNDRED_DOLLAR,
    Denomination_1.Denomination.THREE_HUNDRED_DOLLAR,
    Denomination_1.Denomination.FIVE_HUNDRED_DOLLAR,
].includes(denomination.value));
//# sourceMappingURL=allMoneyDenominations.js.map